import { render, staticRenderFns } from "./Scans.vue?vue&type=template&id=c6180f5a&scoped=true"
import script from "./Scans.vue?vue&type=script&lang=js"
export * from "./Scans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6180f5a",
  null
  
)

export default component.exports